<template>
    <v-app>
      <router-view />
    </v-app>
  </template>
  
  <script>
  export default {
    components: { },
    data() {
      return {
        clipped: false,
        drawer: true,
        eventEmit: null,
        drawerLeft: window.innerWidth > 1263 ? true : false,
        drawerRight: false,
        itemsTopMenu: [],
        windowWidth: window.innerWidth
      };
    },
    computed: {
      buttonsRaceEdit() {
        return [
          {
            title: this.$t("top-menu.all.dashboard"),
            icon: "far fa-tachometer",
            name: "PromoterDashboard",
          },
          {
            title: this.$t("top-menu.raceEdit.participants"),
            icon: "far fa-clipboard",
            name: false,
            items: [
              {
                indexTitle: "top-menu.raceEdit.participantsItems.newParticipant",
                icon: "far fa-user-plus",
                name: "NewParticipant"
              },
              {
                indexTitle: "top-menu.raceEdit.participantsItems.participant-scores",
                icon: "far fa-clock",
                name: "ParticipantScores"
              },
              {
                indexTitle: "top-menu.raceEdit.participantsItems.deleteClass",
                icon: "far fa-trash",
                name: "DeleteClassScore"
              },
            ]
          },
          {
            title: this.$t("top-menu.raceEdit.scores"),
            icon: "far fa-clock",
            name: false,
            items: [
              {
                indexTitle: "top-menu.raceEdit.scoresItems.quickScore",
                icon: "far fa-fire",
                name: "QuickScore"
              },
              {
                indexTitle: "top-menu.raceEdit.scoresItems.addDnf",
                icon: "far fa-users",
                name: "AddDNFParticipants"
              },
              {
                indexTitle: "top-menu.raceEdit.scoresItems.clearScores",
                icon: "far fa-times-circle",
                name: "ClearAllScores"
              },
              {
                indexTitle: "top-menu.raceEdit.scoresItems.importScore",
                icon: "far fa-downlraceDetailsoad",
                name: "ImportScoresFromRace"
              },
            ]
          },
          {
            title: this.$t("top-menu.raceEdit.back"),
            icon: "far fa-tags",
            name: "raceDetails",
          },
        ];
      }
    },
    methods: {
      changeBand({index,value}) {
        this[index] = value;
      },
      loadTopMenuResponsive (items) {
        this.itemsTopMenu = items;
      },
      loadEventRace (item) {
        this.eventEmit = item;
      },
      changeDrawerLeft (value) {
        this.drawerLeft = value;
      },
      changeDrawerRight (value) {
        this.drawerRight = value;
      }
    },
    mounted() {
      const parent = this;
      window.addEventListener('resize', () => {
        parent.windowWidth = window.innerWidth;
      });
      let html = document.getElementsByTagName('html');
      if(html && html.length > 0) {
        html[0].style.overflowY = 'auto';
      }
    },
    created() {}
  };
  </script>
  
  <style lang="scss">
  #contentMain { height: 100vh; }
  .position-relative { position: relative !important; }
  .width-full { width: 100%; }
  .position-absolute { position: absolute; }
  .d-sidebar-right { display: none; }
  .heightContainerScroll { height: 100vh; max-height: calc(100vh - 117px); }
  .heightMainScroll { max-height: calc(100vh - 117px); }
  @media only screen and (max-width: 1263px) {
    .d-sidebar-right { display: flex; }
    .heightContainerScroll {max-height: calc(100vh - 150px); }
    #main-principal { 
      .v-overlay.v-overlay--active { top: auto !important; }
      .top-navigation { top: auto !important; }
    }
  }
  /* Personalizando */
.theme--light.v-list-item .v-list-item__subtitle,
.theme--light.v-list-item .v-list-item__action-text {color: var(--v-primary-darkend1);}
.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled), .theme--light.v-icon {
    color: var(--v-primary-darken2) !important;
}
.v-list-item .v-list-item__title, .v-list-item .v-list-item__subtitle {color: var(--v-primary-darken2);}
.font-side-custom {font-size: 1rem;}
.container-general {padding: 20px 45px;}
.theme--light.v-list-item--active {background-color: var(--v-accent-base) !important;}
.v-messages__message {color: var(-v--primary-base) !important;}
.theme--light.v-messages {color: var(--v-primary-base) !important;}
.theme--light.v-input input, .theme--light.v-input textarea {color: var(--v-primary-darken2) !important;}
.theme--light.v-btn {color: var(--v-primary-darken2);}
.theme--light.v-btn:hover {color: var(--v-accent-darken1);}
.theme--light.v-btn:focus {color: var(--v-accent-darken2);}
.v-application .headline {color: var(--v-primary-darken2) !important; /*font-size: 14px !important;*/ }
.v-application .white--text {
    color: var(--v-lighten-base) !important;
    caret-color: var(--v-lighten-base) !important;
}
.v-expansion-panel-header--active .v-expansion-panel-header__icon .v-icon {
  color: var(--v-primary-darken1) !important;
  caret-color: var(--v-primary-darken1) !important;
}
.text-customizer-exp {
  color: var(--v-primary-darken1) !important;
  caret-color: var(--v-primary-darken1) !important;
}
.text-customizer-accent {
    color: var(--v-primary-darken2) !important;
    caret-color: var(--v-primary-darken2) !important;
}
.theme--light.v-sheet { color: var(--v-primary-darken2); }
.v-btn:not(.v-btn--outlined).primary, 
.v-btn:not(.v-btn--outlined).success, 
.v-btn:not(.v-btn--outlined).error, 
.v-btn:not(.v-btn--outlined).warning, 
.v-btn:not(.v-btn--outlined).info { color: var(--v-lighten-base); }
.v-btn:not(.v-btn--outlined).secondary, 
.v-btn:not(.v-btn--outlined).accent { color: var(--v-primary-darken2); }
.theme--light.v-subheader { color: var(--v-primary-darken1); }
.theme--light.v-btn.v-btn--has-bg { background-color: var(--v-lighten-base); }
.theme--light.v-chip {border-color: var(--v-secondary-base); color: var(--v-primary-darken2);}
.theme--light.v-chip:not(.v-chip--active) {background: var(--v-secondary-base);}
.v-expansion-panel-header.v-expansion-panel-header--active {
    background-color: var(--v-lighten-base) !important;
    color: var(--v-primary-darken3) !important;
}
button.primary {background-color: var(--v-primary-base) !important; border-color: var(--v-primary-base) !important;}
.v-expansion-panel-header {background-color: var(--v-lighten-base) !important;}
.theme--light.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn .v-icon {color: var(--v-lighten-base);}
.theme--light.v-stepper .v-stepper__step__step .v-icon {color: var(--v-lighten-base) !important;}
.v-btn > .v-btn__content .v-icon {color: inherit !important;}
.theme--light.v-card > .v-card__text, .theme--light.v-card .v-card__subtitle {color: var(--v-primary-darken1);}
.theme--light.v-stepper .v-stepper__step--editable:hover .v-stepper__label {
    text-shadow: 0px 0px 0px var(--v-primary-darken4);
}
.theme--light.v-stepper .v-stepper__step--complete .v-stepper__label {color: var(--v-primary-darken2);}
.theme--light.v-stepper--non-linear .v-stepper__step:not(.v-stepper__step--complete):not(.v-stepper__step--error) .v-stepper__label {
    color: var(--v-accent-darken3);
}
.theme--light.v-stepper .v-stepper__step--active .v-stepper__label {
    text-shadow: 0px 0px 0px var(--v-primary-darken4);
}
.theme--light.v-stepper .v-stepper__step:not(.v-stepper__step--active):not(.v-stepper__step--complete):not(.v-stepper__step--error) .v-stepper__step__step {
    background: var(--v-accent-darken2);
}
.theme--light.v-stepper .v-stepper__step__step {
    color: var(--v-lighten-base);
}
$accent: var(--v-accent-base);
.theme--light.v-stepper .v-stepper__step--editable:hover {background: '#{$accent}40';}
.theme--light.v-card .v-card__title, .theme--light.v-card .v-card__title, .theme--light.v-sheet .v-card__title, .theme--light.v-sheet .v-card__title {
    background-color: var(--v-accent-base);
    color: var(--v-primary-darken2);
    font-size: 16px;
}
.v-application .blue-grey {background-color: var(--v-accent-darken2) !important; border-color: var(--accent-darken2) !important;}
.theme--light.v-application .text--primary {color: var(--v-primary-darken3) !important;}
.theme--light.v-expansion-panels .v-expansion-panel {color: var(--v-primary-darken2);}
.theme--light.v-label {color: var(--v-primary-base);}
/* Estilos Generales de Tablas Tabulator */
@import "~vue-tabulator/dist/scss/tabulator";
.tabulator .tabulator-header .tabulator-col {background-color: transparent !important;}
.tabulator-header-filter input{border: 1px solid var(--v-primary-base); border-radius: 4px; background-color: var(--v-lighten-darken1);}
.tabulator {border: 1px solid var(--v-accent-darken2); background-color: var(--v-lighten-base);}
.tabulator .tabulator-header {
    border-bottom: 1px solid var(--v-accent-darken2);
    background-color: var(--v-lighten-base);
    color: var(--v-lighten-base);
}
.tabulator .tabulator-tableHolder .tabulator-table {color: var(--v-primary-darken2);}
.tabulator-row.tabulator-row-even {background-color: var(--v-lighten-base);}
.tabulator-row.tabulator-selectable:hover {background-color: var(--v-accent-base);}
/* Estilos Generales de Tablas Vuetify */
/* Estilos para simular una tabla tabulator con v-datatable */
.table-classes div.v-data-table__wrapper {border-radius: 5px; border: 1px solid var(--v-accent-darken2); z-index: 1;}
.table-classes table thead th:not(:first-child) {border-left: 1px solid var(--v-accent-darken2) !important;}
.table-classes table tbody tr td:not(:first-child) {border-left: 1px solid var(--v-accent-darken2) !important;}
.containerDatatable {border-radius: 5px; border: 1px solid var(--v-accent-darken2);max-height: 600px;overflow-y: scroll;}
.containerDatatable .table-classes div.v-data-table__wrapper {border-radius: 5px 0 0 5px; border: none;}
.table-classes .v-data-table-header {background: var(--v-lighten-base);}
.table-classes table thead th {
    border-bottom: 1px solid var(--v-accent-darken2) !important;
    padding: 5px 10px!important;
    height: auto !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.containerDatatable .table-classes table thead th {border-left: none !important; border-right: 1px solid var(--v-accent-darken2) !important;}
.table-classes table thead th span {font-size: 15px; font-weight: bold;}
.table-classes tr:nth-child(even) {background-color: var(--v-lighten-base);}
.table-classes table tbody tr td {border-bottom: none !important; padding: 5px 10px !important; height: auto !important;}
.containerDatatable .table-classes table tbody tr td {border-left: none; border-right: 1px solid var(--v-accent-darken2) !important;}
.table-classes.v-data-table > .v-data-table__wrapper > table > thead > tr > th {color: var(--v-primary-darken1);}
.table-classes.v-data-table .v-data-table-header th.sortable:hover, .theme--light.v-data-table .v-data-table-header th.sortable.active {
    color: var(--v-primary-darken3);
}
.table-classes.v-data-table {color: var(--v-primary-darken2);}
.table-classes.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
    background: var(--v-accent-base) !important;
}
/* Estilos para otras tablas v-datatable */
.v-data-table-header/*, .v-card__title*/ {background: var(--v-lighten-base) !important;}
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {color: var(--v-primary-darken1);}
.theme--light.v-data-table {color: var(--v-primary-darken2);}
.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
    background: var(--v-lighten-base);
}
/* Fin de Adaptaciones*/
.v-app-bar.v-app-bar--fixed {position: relative !important;z-index: 5;}
.v-toolbar__content {padding-left: 0px !important; padding-right: 0px !important;}
@media (max-width: 1263px) {
  .v-navigation-drawer {z-index: 6 !important; width: auto !important;}
  .v-main {padding: 0% 0% 0% 0% !important;}
  .buttonRigth {display: block !important;}
}
@media (min-width: 1263px){
  .breadcrumbHeader {
    display: none !important;
  }
}

@media (max-width: 960px) {
  .container-general {padding: 20px;}
}
@media (max-width: 750px) {
  .container-general {padding: 0px;}
}
@media screen and (max-width: 600px) {
  .bar-breadcrumb, .bar-breadcrumb .v-toolbar__content, .toolbar-breadcrumb, .toolbar-breadcrumb .v-toolbar__content {
    height: max-content !important;
  }
  .bar-breadcrumb .v-breadcrumbs {padding: 0 18px;}
}
.main-layout {/*height:100%; */margin-bottom: 30px; padding-top: 0 !important;}
.btn-all-right {margin: 0 0 0 auto;}
.btn-all-left {margin-left: 1em;}
.activeHC .theme--light.v-list-item--active {background-color: transparent !important;}
.activeHC.active .v-list-group__header {background-color: var(--v-accent-base) !important;}
.v-select.v-input--dense .v-chip {margin: 3px 4px 0 4px;}
  </style>